import styled from 'styled-components';

const BRAND_COLOR = '#0B2A1B';

export const InvestigationSelectionWrapper = styled.div`
  width: 100%;
  padding: 24px;

  .back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${BRAND_COLOR};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    margin-bottom: 24px;

    &:hover {
      text-decoration: underline;
    }
  }

  .incident-details-card {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 24px;
    margin-bottom: 24px;
  }

  .incident-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .incident-report-number {
    font-size: 24px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 8px 0;
  }

  .incident-description {
    font-size: 16px;
    color: #667085;
    margin: 0;
  }

  .severity-badge {
    padding: 4px 12px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .severity-high {
    background: #fee2e2;
    color: #991b1b;
  }

  .severity-medium {
    background: #ffedd5;
    color: #9a3412;
  }

  .severity-low {
    background: #fef9c3;
    color: #854d0e;
  }

  .incident-meta-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .meta-label {
    font-size: 12px;
    color: #667085;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
  }

  .meta-value {
    font-size: 14px;
    font-weight: 500;
    color: #101828;
    white-space: pre-wrap;
    line-height: 1.5;
  }

  .incident-detail-rows {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .detail-row {
    break-inside: avoid;
  }

  .section-title {
    font-size: 20px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .section-subtitle {
    font-size: 14px;
    color: #667085;
    margin-bottom: 24px;
  }

  .framework-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .framework-card {
    background: #fff;
    border-radius: 12px;
    border: 2px solid #e5e7eb;
    padding: 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
      border-color: ${BRAND_COLOR};
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .framework-card-disabled {
    opacity: 0.55;
    cursor: not-allowed;
    background: #f9fafb;

    &:hover {
      border-color: #e5e7eb;
      box-shadow: none;
    }

    .framework-icon {
      filter: grayscale(40%);
    }
  }

  .coming-soon-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #e5e7eb;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 9999px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .framework-card-selected {
    border-color: ${BRAND_COLOR};
    box-shadow: 0 0 0 1px ${BRAND_COLOR}, 0 4px 12px rgba(0, 0, 0, 0.1);
    background: #f0f5f2;

    &::after {
      content: '';
      position: absolute;
      top: 12px;
      right: 12px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: ${BRAND_COLOR};
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
      background-size: 14px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .framework-card-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .framework-icon {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    transition: background 0.2s ease;
  }

  .framework-icon-amber {
    background: #fef3c7;
    color: #d97706;
  }

  .framework-card:hover .framework-icon-amber {
    background: #fde68a;
  }

  .framework-icon-teal {
    background: #ccfbf1;
    color: #0d9488;
  }

  .framework-card:hover .framework-icon-teal {
    background: #99f6e4;
  }

  .framework-icon-purple {
    background: #f3e8ff;
    color: #7c3aed;
  }

  .framework-card:hover .framework-icon-purple {
    background: #e9d5ff;
  }

  .framework-icon-indigo {
    background: #e0e7ff;
    color: #4f46e5;
  }

  .framework-card:hover .framework-icon-indigo {
    background: #c7d2fe;
  }

  .framework-title {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .framework-description {
    font-size: 14px;
    color: #667085;
    margin-bottom: 16px;
  }

  .framework-features {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .framework-feature {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #667085;
  }

  .feature-check {
    color: #16a34a;
    font-size: 16px;
    flex-shrink: 0;
  }

  .investigation-in-progress {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    color: ${BRAND_COLOR};
    font-size: 12px;
    font-weight: 500;
  }

  /* Classification Form */
  .classification-form-card {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 24px;
    margin-bottom: 24px;
  }

  .form-section-title {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 20px;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 8px;
  }

  .btn-classify {
    background-color: ${BRAND_COLOR} !important;
    border-color: ${BRAND_COLOR} !important;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;

    &:hover {
      opacity: 0.85;
    }
  }

  .ant-form-item-label > label {
    font-weight: 500;
    color: #344054;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector {
    border-radius: 8px !important;
  }

  /* Guidelines */
  .guidelines-card {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 12px;
    padding: 20px;
  }

  .guidelines-title {
    font-size: 16px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .guidelines-icon {
    color: #2563eb;
    font-size: 20px;
  }

  .guidelines-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .guidelines-list li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    color: #667085;
  }

  .guidelines-bullet {
    color: #2563eb;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .not-found-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .not-found-title {
    font-size: 24px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .not-found-link {
    color: ${BRAND_COLOR};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;
